type Tone = 'ok' | 'warn' | 'err' | 'muted' | 'active'

const toneClass: Record<Tone, { dot: string; ring: string }> = {
  ok: { dot: 'bg-radar-green', ring: 'after:bg-radar-green/60' },
  warn: { dot: 'bg-amber-glow', ring: 'after:bg-amber-glow/60' },
  err: { dot: 'bg-radar-red', ring: 'after:bg-radar-red/60' },
  muted: { dot: 'bg-paper-trace', ring: 'after:bg-transparent' },
  active: { dot: 'bg-radar-cyan', ring: 'after:bg-radar-cyan/60' },
}

export function StatusDot({ tone = 'muted', pulse = false }: { tone?: Tone; pulse?: boolean }) {
  const c = toneClass[tone]
  return (
    <span
      className={`
        relative inline-flex items-center justify-center w-2 h-2
        after:content-[''] after:absolute after:inset-0 after:rounded-full
        ${pulse ? 'after:animate-radar-pulse' : ''} ${c.ring}
      `}
    >
      <span className={`w-2 h-2 ${c.dot} rounded-full`} />
    </span>
  )
}
